import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {KYCProfile} from '../entity/kyc-verification';
import {Http} from "@angular/http";


@Injectable()
export class KycService {

    constructor(private _http: Http) {
    }

    getResult(profileId: number): Observable<KYCProfile> {
        return this._http.get(`/api/backoffice/verification/kyc/${profileId}`)
            .map(response => response.json());
    }

    verifyOrUpdateProfile(profileId: number): Observable<any> {
        return this._http.post(`/api/backoffice/verification/kyc`, {clientProfileId: profileId});
    }

    getCRAFile(profileId: number): Observable<KYCProfile> {
        return this._http.get(`/api/backoffice/download/cra/${profileId}`)
            .map(response => response.json());
    }

    downloadFile(data: Response) {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
    }

    getAOB(profileId: number): Observable<string> {
        return this._http.get(`/api/backoffice/verification/aob/${profileId}`)
          .map(response => response.text());
    }

    saveReason(profileId: number, reason: string): Observable<any> {
        return this._http.post(`/api/backoffice/verification/kyc/approval`, {
            clientProfileId: profileId,
            reason: reason
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/kyc.service.ts